import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import { GET_BRAINTREE_CLIENT_TOKEN_ENDPOINT } from "../../_actions/endpoints";
import { handleHTTPError } from "../../_actions/errorHandlerActions";
import { PaymentSources } from "../../_actions/types";
import TldrBillingPlansCard from "./TldrBillingPlansCard";
import TldrPaymentSummary from "./TldrPaymentSummary";

function TldrUpgradePlanCheckout({
  onClose,
  selectedPlan,
  cartItems,
  handleStripeCheckout,
  isLoading,
  setUpgradePlanStep,
  planIndex,
  yearlyInterval,
}) {
  const [clientToken, setClientToken] = useState(null);
  const { t } = useTranslation(["billing"]);

  const [isPaypalLoading, setIsPaypalLoading] = useState(false);
  const isMobileView = useSelector((state) => state.app.isMobileView);
  const subscription = useSelector((state) => state.subscription);
  let isShopify = subscription?.subscribedPlan?.source === PaymentSources.SHOPIFY;

  useEffect(() => {
    if(isShopify){
      return
    }
    axios
      .get(GET_BRAINTREE_CLIENT_TOKEN_ENDPOINT)
      .then((res) => {
        setClientToken(res.data.token);
      })
      .catch((error) => handleHTTPError(error));
  }, [isShopify]);

  return (
    <Flex direction={["column", "column", "column", "row"]}>
      <Flex flex={1} minH="500px">
        <Box w="full">
          <Flex align={"center"} justify="space-between">
            <Flex align={"center"}>
              <IconButton
                size="sm"
                autoFocus={false}
                variant={"ghost"}
                onClick={() => setUpgradePlanStep((prev) => prev - 1)}
                fontSize="lg"
                icon={<FaChevronLeft />}
                m={4}
              />
              <Text fontSize={"lg"} fontWeight={500}>
                {t("choose_plan_and_pay_modal.title")}
              </Text>
            </Flex>
          </Flex>
          <Box
            py={4}
            px={isMobileView ? 4 : 12}
            h={isMobileView ? "536px" : "436px"}
          >
            <Flex gap={isMobileView ? 0 : 4}>
              <Box
                flex={1}
                display={["none", "none", "none", "block"]}
                mx={10}
                mt={20}
              >
                <TldrBillingPlansCard
                  plan={selectedPlan}
                  showSummary={true}
                  planIndex={planIndex + 1}
                  notSelectable
                  yearlyInterval={yearlyInterval}
                />
              </Box>
              <Box flex={1} px={4}>
                <TldrPaymentSummary
                  clientToken={clientToken}
                  setIsPaypalLoading={setIsPaypalLoading}
                  handleStripeCheckout={handleStripeCheckout}
                  cartItems={cartItems}
                  isLoading={isLoading}
                  onClose={onClose}
                  selectedPlan={selectedPlan}
                />
              </Box>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default TldrUpgradePlanCheckout;
